const PropTypes = require('prop-types')

// window.Element is only available in web browsers
const Element = typeof window !== 'undefined'
? window.Element
: function () {}

const domElement = PropTypes.instanceOf(Element)

/** @see https://stackoverflow.com/a/51127130 */
const domRef = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: domElement })
])

module.exports = {
  domElement,
  domRef
}
